<template>
  <div class="loading" v-if="showLoading">
    <div class="loading-area">
      <section clas="loading_vn">
        <div class="loader">
          <div class="upper ball"></div>
          <div class="right ball"></div>
          <div class="lower ball"></div>
          <div class="left ball"></div>
        </div>
      </section>
      <span v-text="text"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLoading: {
      default: false,
      type: Boolean
    },
    text: {
      // default: "Đang gửi dữ liệu...",
      type: String
    }
  }
};
</script>

<style scoped>
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  background-color: rgba(38, 50, 56, 0.3);
}

.loading-area {
  padding: 10px;
}

.loading-area span {
  padding: 0 2vw;
}

.close-button {
  width: 2em;
  height: 2em;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue